import { BaseDesignOption } from '@/modules/ta/reportstudio/models/element/metadata/BaseDesignOption';
import { ReportElementImageSupportedFillMode } from '@/modules/ta/reportstudio/reportstudio.constants';

export class ImageDesignOption extends BaseDesignOption {
  /**
   * @type {boolean}
   */
  show_on_every_page;

  /**
   * @type {string}
   */
  fill_mode;

  constructor(model = {}) {
    super();
    this.show_on_every_page = model.show_on_every_page ?? true;
    this.fill_mode = model.fill_mode ?? ReportElementImageSupportedFillMode.ASPECT_FIT;
  }
}
